import React from 'react';

const CateringDetails = ({cateringDetails, isLoading, onClose, bookingId}) => {
    console.log(cateringDetails[0]);
    if (isLoading) {
        return (
            <tr>
                <td
                    colSpan='9'
                    style={{
                        backgroundColor: '#f8f9fa',
                        padding: '20px',
                        textAlign: 'center',
                    }}
                >
                    <div className='d-flex justify-content-center align-items-center'>
                        <div className='spinner-border' role='status'>
                            <span className='sr-only'>Loading...</span>
                        </div>
                        <span className='ml-2'>
                            Loading catering details...
                        </span>
                    </div>
                </td>
            </tr>
        );
    }

    if (!cateringDetails) {
        return (
            <tr>
                <td
                    colSpan='9'
                    style={{
                        backgroundColor: '#f8f9fa',
                        padding: '20px',
                        textAlign: 'center',
                    }}
                >
                    <div className='alert alert-warning mb-0'>
                        <i className='las la-exclamation-triangle mr-2'></i>
                        No details available for this catering order.
                        <button
                            type='button'
                            className='btn btn-outline-secondary btn-sm ml-3'
                            onClick={() => onClose(bookingId)}
                        >
                            Close
                        </button>
                    </div>
                </td>
            </tr>
        );
    }

    const formatTime = timeString => {
        if (!timeString) return 'Not specified';
        const time = timeString.slice(0, 5); // Get HH:MM format
        const [hours, minutes] = time.split(':');
        const hour = parseInt(hours);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const displayHour = hour % 12 || 12;
        return `${displayHour}:${minutes} ${ampm}`;
    };

    return (
        <tr>
            <td
                colSpan='9'
                style={{
                    backgroundColor: '#f8f9fa',
                    padding: '0',
                    border: 'none',
                }}
            >
                <div style={{padding: '20px', position: 'relative'}}>
                    <button
                        type='button'
                        className='btn btn-outline-secondary btn-sm'
                        style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                        }}
                        onClick={() => onClose(bookingId)}
                    >
                        <i className='las la-times'></i> Close
                    </button>

                    <h5 className='mb-3' style={{paddingRight: '80px'}}>
                        Catering Order Details
                    </h5>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='mb-3'>
                                <strong className='text-primary'>
                                    Order Information
                                </strong>
                                <div className='mt-2'>
                                    <p className='mb-1'>
                                        <strong>Event ID:</strong>{' '}
                                        {cateringDetails[0].eventid}
                                    </p>
                                    <p className='mb-1'>
                                        <strong>Date:</strong>{' '}
                                        {cateringDetails[0].date}
                                    </p>
                                    <p className='mb-1'>
                                        <strong>Time:</strong>{' '}
                                        {formatTime(cateringDetails[0].time)}
                                    </p>
                                    <p className='mb-1'>
                                        <strong>Service Type:</strong>{' '}
                                        {cateringDetails[0].serv_type}
                                    </p>
                                    <p className='mb-1'>
                                        <strong>Number of Guests:</strong>{' '}
                                        {cateringDetails[0].nog}
                                    </p>
                                    <p className='mb-1'>
                                        <strong>Order Time:</strong>{' '}
                                        {cateringDetails[0].time}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className='mb-3'>
                                <strong className='text-primary'>
                                    Customer Information
                                </strong>
                                <div className='mt-2'>
                                    <p className='mb-1'>
                                        <strong>Customer:</strong>{' '}
                                        {cateringDetails[0].customer}
                                    </p>
                                    <p className='mb-1'>
                                        <strong>Mobile:</strong>{' '}
                                        {cateringDetails[0].mobile}
                                    </p>
                                    <p className='mb-1'>
                                        <strong>Location:</strong>{' '}
                                        {cateringDetails[0].location}
                                    </p>
                                    <p className='mb-1'>
                                        <strong>Address:</strong>{' '}
                                        {cateringDetails[0].address}
                                    </p>
                                    <p className='mb-1'>
                                        <strong>Location Type:</strong>{' '}
                                        {cateringDetails[0].location_type}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='mb-3'>
                                <strong className='text-primary'>
                                    Pricing Information
                                </strong>
                                <div className='mt-2'>
                                    <p className='mb-1'>
                                        <strong>Confirmed Budget:</strong> SAR{' '}
                                        {cateringDetails[0].customer_budget}
                                    </p>
                                    <p className='mb-1'>
                                        <strong>Bid Amount:</strong> SAR{' '}
                                        {cateringDetails[0].quote_amount}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className='mb-3'>
                                <strong className='text-primary'>
                                    Service Options
                                </strong>
                                <div className='mt-2'>
                                    <p className='mb-1'>
                                        <strong>Live Cooking:</strong>
                                        <span
                                            className={`ml-2 ${
                                                cateringDetails[0].live_cook
                                                    ? 'text-success'
                                                    : 'text-warning'
                                            }`}
                                        >
                                            {cateringDetails[0].live_cook
                                                ? 'Yes'
                                                : 'No'}
                                        </span>
                                    </p>
                                    <p className='mb-1'>
                                        <strong>Pre Cooking:</strong>
                                        <span
                                            className={`ml-2 ${
                                                cateringDetails[0].pre_cook
                                                    ? 'text-success'
                                                    : 'text-warning'
                                            }`}
                                        >
                                            {cateringDetails[0].pre_cook
                                                ? 'Yes'
                                                : 'No'}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='mb-3'>
                                <strong className='text-primary'>
                                    Status Information
                                </strong>
                                <div className='mt-2'>
                                    <div className='row'>
                                        <div className='col-md-4'>
                                            <p className='mb-1'>
                                                <strong>
                                                    Restaurant Status:
                                                </strong>
                                                <span
                                                    className={`ml-2 ${
                                                        cateringDetails[0]
                                                            .is_rest_accepted
                                                            ? 'text-success'
                                                            : 'text-warning'
                                                    }`}
                                                >
                                                    {cateringDetails[0]
                                                        .is_rest_accepted
                                                        ? 'Accepted'
                                                        : 'Not Accepted'}
                                                </span>
                                            </p>
                                        </div>
                                        <div className='col-md-4'>
                                            <p className='mb-1'>
                                                <strong>
                                                    Customer Status:
                                                </strong>
                                                <span
                                                    className={`ml-2 ${
                                                        cateringDetails[0]
                                                            .is_cust_accepted
                                                            ? 'text-success'
                                                            : 'text-warning'
                                                    }`}
                                                >
                                                    {cateringDetails[0]
                                                        .is_cust_accepted
                                                        ? 'Accepted'
                                                        : 'Not Accepted'}
                                                </span>
                                            </p>
                                        </div>

                                        <div>
                                            <p className='mb-1'>
                                                <strong>Bid Status:</strong>
                                                <span
                                                    className={`ml-2 ${
                                                        cateringDetails[0].event_bid_status.toLowerCase() ===
                                                        'confirmed'
                                                            ? 'text-success'
                                                            : cateringDetails[0].event_bid_status.toLowerCase() ===
                                                              'live'
                                                            ? 'text-primary'
                                                            : 'text-warning'
                                                    }`}
                                                >
                                                    {
                                                        cateringDetails[0]
                                                            .event_bid_status
                                                    }
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            {cateringDetails[0]
                                                .completed_time && (
                                                <p className='mb-1'>
                                                    <strong>
                                                        Completed Time:
                                                    </strong>{' '}
                                                    {new Date(
                                                        cateringDetails[0].completed_time
                                                    ).toLocaleString()}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='mb-3'>
                                <strong className='text-primary'>
                                    Order Details
                                </strong>
                                <div>
                                    <div className='mt-2'>
                                        <p
                                            className='mb-0'
                                            style={{whiteSpace: 'pre-wrap'}}
                                        >
                                            {cateringDetails[0].order_details}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='mb-3'>
                                <strong className='text-primary'>
                                    Cuisines
                                </strong>
                                <div className='mt-2'>
                                    <p
                                        className='mb-0'
                                        style={{whiteSpace: 'pre-wrap'}}
                                    >
                                        {cateringDetails[0].cuisine.join(',')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    );
};

export default CateringDetails;
